$(document).ready(function() {
    if($('.homepage-distribution .distribution-slider').html() != undefined) {

		var advantagesSliderOptions = {
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 480,
					settings: {
						adaptiveHeight: true,
					}
				}
			]
		};
		var sliderElement = $('.distribution-slider');
		sliderElement.slick(advantagesSliderOptions);
    }
});